require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-microsoft-hackathon-cloudthing-make-a-wish-london.json") })
        }
      }, "path---blog-microsoft-hackathon-cloudthing-make-a-wish-london");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-microsoft-hackathon-cloudthing-make-a-wish-london!./.cache/json/blog-microsoft-hackathon-cloudthing-make-a-wish-london.json
// module id = 832
// module chunks = 231608221292675